(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/self-exclusion-react/assets/react/models/date-structure.js') >= 0) return;  svs.modules.push('/modules/self-exclusion-react/assets/react/models/date-structure.js');
'use strict';

const currentDate = new Date();
const dates = [{
  id: 0,
  text: '3 månader',
  value: 3,
  isExcluded: false,
  willExpire: dateFns.addMonths(currentDate, 3)
}, {
  id: 1,
  text: '6 månader',
  value: 6,
  isExcluded: false,
  willExpire: dateFns.addMonths(currentDate, 6)
}, {
  id: 2,
  text: '1 år',
  value: 12,
  isExcluded: false,
  willExpire: dateFns.addYears(currentDate, 1)
}, {
  id: 3,
  text: '3 år',
  value: 36,
  isExcluded: false,
  willExpire: dateFns.addYears(currentDate, 3)
}];
svs.selfExclusion.dates = dates;

 })(window);